import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "19", cy: "5", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "5", cy: "19", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10.4 21.9a10 10 0 0 0 9.941-15.416", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M13.5 2.1a10 10 0 0 0-9.841 15.416", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Orbit";
const Orbit = memo(themed(Icon));
export {
  Orbit
};
//# sourceMappingURL=orbit.js.map
